export let sucursal = JSON.parse(localStorage.getItem("sucursal")) || {};
export let token = localStorage.getItem("token") || undefined;
